"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseManipulator = void 0;
var BaseManipulator = (function () {
    function BaseManipulator(manipulator) {
        this.modelManipulator = manipulator;
    }
    Object.defineProperty(BaseManipulator.prototype, "history", {
        get: function () { return this.modelManipulator.modelManager.history; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseManipulator.prototype, "model", {
        get: function () { return this.modelManipulator.modelManager.model; },
        enumerable: false,
        configurable: true
    });
    return BaseManipulator;
}());
exports.BaseManipulator = BaseManipulator;
